import { FilterStoreHook } from 'libs/end-to-end/src/filters-v2/types/filters-v2.types';
import { EntitledDetailsInContextOfFiltersFeatureName } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { getSelectedMetric } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { determineFilterStoreScope } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { PrimaryFilterSelection } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { FiltersFeatureName } from 'libs/end-to-end/src/filters-v2/filter-utils';
import { getPrimaryFilterFullKey } from 'libs/end-to-end/src/filters-v2/filter-utils';
import React, { useMemo } from 'react';
import { FilterMenuSinglePanel } from 'apps/sigma2-ui/src/filters-v2/components/FilterMenuSinglePanel';
import { FilterListBox } from 'apps/sigma2-ui/src/filters-v2/components/FilterListBox';
import { FocusArea } from 'libs/end-to-end/src/focus-area';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { MyMetricDefinition } from 'libs/end-to-end/src/my-metric-definition';

export const MetricSingleMenu = ({
  entitledFilterFeatureDetails,
  store,
  feature,
  databaseRevisionId,
  databaseId,
  organizationId,
  closeMenu,
  setPrimaryFilters,
  focusArea,
  analysisName,
}: {
  entitledFilterFeatureDetails: EntitledDetailsInContextOfFiltersFeatureName;
  store: FilterStoreHook;
  feature: FiltersFeatureName;
  organizationId: string;
  databaseId: string;
  databaseRevisionId: string;
  closeMenu: () => void;
  setPrimaryFilters: (params: {
    selections: PrimaryFilterSelection[];
    shouldPreventAutoSubmit?: boolean;
  }) => void;
  focusArea: FocusArea;
  analysisName: string | undefined;
}) => {
  const language = useLanguage();

  const items = useMemo(() => {
    const currentMetric = getSelectedMetric({
      feature,
      organizationId,
      databaseRevisionId,
      databaseId,
      store,
      focusArea,
      analysisName,
    });

    const fullKey = getPrimaryFilterFullKey({
      primaryFilterKey: 'metric',
    });

    const scope = determineFilterStoreScope({
      feature,
      fullKey,
      databaseId,
      databaseRevisionId,
      organizationId,
      focusArea,
      analysisName,
    });

    if (!scope) {
      return [];
    }

    return entitledFilterFeatureDetails.focusAreaMetrics.map((metric) => ({
      value: metric.columnHeaderValue,
      translatedContent: language.metricDisplayName({
        definition: metric,
      }),
      selected: metric.columnHeaderValue === currentMetric,
    }));
  }, [
    feature,
    organizationId,
    databaseRevisionId,
    databaseId,
    store,
    focusArea,
    analysisName,
    entitledFilterFeatureDetails.focusAreaMetrics,
    language,
  ]);

  return (
    <FilterMenuSinglePanel
      filterContent={
        <FilterListBox
          multiple={false}
          items={items}
          onUpdate={({ addedSelections }) => {
            const primaryFiltersSelections: PrimaryFilterSelection[] = [
              {
                primaryFilterKey: 'metric',
                value: addedSelections[0],
              },
            ];

            setPrimaryFilters({ selections: primaryFiltersSelections });

            closeMenu();
          }}
        />
      }
      bottomProps={'none'}
    />
  );
};
